export { ACTOR } from 'ui-product-approvals-common/constants/actors';
export const DEFAULT_AGENT_APPROVER_ID = 'approvals-agent-v0';